import { If } from "components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AttributeTypes } from "../../../../constants";
import { AttributeBlock } from "../../../AttributeBlock";
import { AttributeField } from "../../../AttributeField";
import { AdditionalAttributesBlockProps } from "../SubChildCategoryForm.types";

const AdditionalAttributesBlock = ({
  control,
  attributes,
  isMaxMainFilters,
  onAppendAttribute,
  onRemoveAttribute
}: AdditionalAttributesBlockProps) => {
  const { t } = useTranslation();

  return (
    <AttributeBlock
      title={t("Additional attributes")}
      subtitle={t(
        "Values for each additional attribute will be selected from dropdown while creating a product."
      )}
      appendLabel={t("Add additional attribute")}
      onAppend={onAppendAttribute(AttributeTypes.Additional)}
    >
      {attributes.map((attribute, attributeIndex) => {
        return (
          <If
            key={attribute.attributeId}
            condition={
              attribute.type === AttributeTypes.Additional && !attribute.delete
            }
          >
            <Controller
              control={control}
              name={`attributes.${attributeIndex}`}
              render={({
                field: { value, onChange },
                fieldState: { error }
              }) => (
                <AttributeField
                  placeholder={t("Add attribute value (enter to apply)")}
                  variant="primary"
                  value={value}
                  onChange={onChange}
                  errorMessage={error}
                  disabledMainFilter={isMaxMainFilters}
                  onDelete={onRemoveAttribute(attributeIndex)}
                />
              )}
            />
          </If>
        );
      })}
    </AttributeBlock>
  );
};

export default AdditionalAttributesBlock;
